import { useState } from "react"
import RenderField from "./RenderField"
import RenderFieldWidget from "./Encounter Widgets/RenderField"; // just to add it as unique component imported as RenderFieldWidget
import RenderGroupField from "./Group Encounter Widgets/RenderGroupField";
// import EncounterWidgets from "./Encounter Widgets/EncounterWidgets";

const CustomTemplateFormVGroup = (props) => {
    const { customTemplateData, setCustomTemplateData, setSaveCustomTemplateData, validations, formData, isGroupNote } = props
    const { itemsCollapsed, handleItemsExpanded = () => { } } = props;
    // console.log("customTemplateData123SOAP", customTemplateData,)
    // console.log("customTemplateData123validations", validations)
    // const[ data, setData] = useState(customTemplateData?.[0])
    const index = props?.index ?? 0; // defaults to 0 so MainCustomTemplate (single-item) callers are unaffected
    const currentItem = customTemplateData?.[index];
    const data = currentItem?.Data;

    console.log(data, 'CustomTemplateFormVGroup');

    const setData = (updater) => { // updater
        setCustomTemplateData(prev => {
            const prevItem = prev?.[index] || {};
            const updatedValue = updater(prevItem?.Data || [])
            const updatedState = prev.map((item, i) => i === index ? { ...item, Data: updatedValue } : item);

            setSaveCustomTemplateData(savePrev => {
                const list = savePrev || [];
                let exists = false;

                const updated = list.map(item => {
                    const isMatch = prevItem?.ClientTemplateID
                        ? item.ClientTemplateID === prevItem.ClientTemplateID
                        : item.PatientIntakeFormID === prevItem.PatientIntakeFormID;
                    if (isMatch) {
                        exists = true;
                        return { ...item, Data: updatedValue };
                    }
                    return item;
                });
                // if not found in save, add it (initial case)
                if (!exists) {
                    return [...updated, { ...prevItem, Data: updatedValue }];
                }
                return updated;
            });
            return updatedState
        })
    }

    const handleRemoveCustomTemplate = () => {
        setCustomTemplateData(prev => {
            const prevItem = prev?.[index];

            setSaveCustomTemplateData(savePrev => {
                // CASE 1: new unsaved item  (remove only that item)
                if (prevItem?.PatientIntakeFormID === "0") {
                    return savePrev?.filter(x =>
                        prevItem?.ClientTemplateID
                            ? x.ClientTemplateID !== prevItem?.ClientTemplateID
                            : x.PatientIntakeFormID !== prevItem?.PatientIntakeFormID
                    ) || [];
                }
                // CASE 2: item already exists in save state
                const existing = savePrev?.find(x =>
                    prevItem?.ClientTemplateID
                        ? x.ClientTemplateID === prevItem?.ClientTemplateID
                        : x.PatientIntakeFormID === prevItem?.PatientIntakeFormID
                );
                if (existing) {
                    return savePrev.map(x =>
                        (prevItem?.ClientTemplateID
                            ? x.ClientTemplateID === prevItem?.ClientTemplateID
                            : x.PatientIntakeFormID === prevItem?.PatientIntakeFormID)
                            ? { ...x, Deleted: "true" } : x);
                }
                // CASE 3: item not found in save state
                // append delete record without losing old records
                return [...(savePrev || []), { ...prevItem, Deleted: "true" }];
            });

            return prev.filter((_, i) => i !== index);
        });
    }

    let count = 0;
    const excludedNames = ["Heading", "TextField", "Divider"];
    const customTemplateFormType = props?.CustomTemplateFormType === "MainCustomTemplate" ? 'MCF' : 'CF';
    // Per-instance collapse key so multiple templates in the same slot
    // (Top/Bottom) collapse/expand independently instead of all together.
    const collapseKey = `${customTemplateFormType}_${index}`;
    let { scrollNavIDs, handleHoveredItem = () => { }, handleActiveItem = () => { }, encounterID } = props?.scrollNavUtilities || {};
    if (!data) return null; // guard: nothing to render if this slot's data isn't populated
    return (<>
        <div className="d-flex justify-content-between align-items-center pt-1-5">
            <div className="ar_header d-flex gap-6 align-items-center mb-1 w-100" onClick={() => handleItemsExpanded(collapseKey)}>
                {!itemsCollapsed?.[collapseKey] ? <i className="icon-up fs-10 pt-2px"></i> : <i className="icon-down fs-10 pt-2px"></i>}
                <p className="text fs-13 font-b validate-color blue-bg">{currentItem?.TemplateName ? `CT - ${currentItem?.TemplateName}` : 'CUSTOM TEMPLATE'}</p>
            </div>
            {/* <div className="orange-alert text-nowrap user-select-none">
                    <div className='ar-alert d-flex m-0 me-1 py-1'>
                    </div>
                </div> */}
        </div>
        {!itemsCollapsed?.[collapseKey] &&
            (<div>
                <div className="Form-import-edit-view d-flex flex-column gap-30">
                    <div className="d-flex flex-column gap-12">
                        {props?.isCustomNote === "true" ? <></> :
                            <div className="d-flex justify-content-end">
                                <i className="icon-x-cros fs-15 dark-clr fw-bold" onClick={handleRemoveCustomTemplate}></i>
                            </div>}
                        <div className="ar_pat-info-form-fill h-auto">
                            <div className="ar_fill-content-box p-0 w-auto">
                                <div className="ar-intake-form-fill ar_star-form-Preview">
                                    <div className="Form-content d-flex flex-column gap-10 h-100 p-0 overflow-visible">
                                        {data[0]['items'].map((it, itemIndex) => {
                                            const shouldCount = !excludedNames.some(name => it?.ItemID?.includes(name));
                                            const itemCount = shouldCount ? ++count : null;
                                            const itemNavigationID = `ref${customTemplateFormType}${encounterID}${index}_${itemIndex}`
                                            const refId = scrollNavIDs?.[itemNavigationID];
                                            return (
                                                <div className='is-empty' id={refId} onMouseEnter={() => handleHoveredItem(refId)} onClick={() => handleActiveItem(refId)}>
                                                    {it?.IsWidget === "true" && !isGroupNote ?
                                                        <RenderGroupField
                                                            item={it}
                                                            setItem={setData}
                                                            widgetUtilities={props?.widgetUtilities}
                                                            itemCount={itemCount}
                                                            activeAccordion={data?.[0]?.key || 'Intake Form'}
                                                            isGroupNote={isGroupNote}
                                                        /> :
                                                        <RenderField
                                                            item={it}
                                                            setItem={setData}
                                                            validations={validations?.[it?.ItemID]}
                                                            activeAccordion={data?.[0]?.key || 'Intake Form'}
                                                            patientName={formData?.PatientName}
                                                            itemCount={itemCount}
                                                            isGroupNote={isGroupNote}
                                                            itemRefKey={refId}
                                                        />
                                                    }
                                                </div>
                                            )
                                        })
                                        }

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>)}
    </>)
}

export default CustomTemplateFormVGroup